import toast from 'react-hot-toast';

export default (text) => toast(text);
